module.exports = __webpack_public_path__ + "static/media/users.82bc5017.svg";